

// Récupérer les assets stockés localement
const getStoredAssets = () => {
  const storedAssets = localStorage.getItem(ASSETS_STORAGE_KEY);
  return storedAssets ? JSON.parse(storedAssets) : [];
};


// Générer un ID unique simple
const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

// Fonction pour uploader réellement un asset dans le dossier public
export const uploadAsset = async (userId, projectId, file, type) => {
  try {
    if (import.meta.env.MODE !== 'production') {
      console.log(`[API] Requête: Upload d'asset - userId: ${userId}, projectId: ${projectId}, fichier: ${file.name}, type: ${type}`);
    }
    
    // Créer un objet FormData pour l'upload
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('projectId', projectId);
    formData.append('type', type);

    // Envoyer le fichier au serveur
    const response = await fetch('/api/upload', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      console.error(`[API] Erreur: Upload d'asset - Status: ${response.status}, Message: ${response.statusText}`);
      throw new Error(`Erreur d'upload: ${response.statusText}`);
    }

    const result = await response.json();
    if (import.meta.env.MODE !== 'production') {
      console.log(`[API] Réponse: Upload d'asset réussi - ID: ${result.id}, URL: ${result.url}`);
    }
    return result;
  } catch (error) {
    console.error("[API] Erreur: Échec de l'upload de l'asset:", error);
    throw error;
  }
};

// Obtenir tous les assets d'un projet en lisant directement le répertoire
export const getProjectAssets = async (userId, projectId) => {
  try {
    if (import.meta.env.MODE !== 'production') {
      console.log(`[API] Requête: Récupération des assets - userId: ${userId}, projectId: ${projectId}`);
    }
    
    // Demander au serveur de lister les fichiers dans le répertoire
    const response = await fetch(`/api/list-assets?userId=${encodeURIComponent(userId)}&projectId=${encodeURIComponent(projectId)}`);
    
    if (!response.ok) {
      console.error(`[API] Erreur: Récupération des assets - Status: ${response.status}, Message: ${response.statusText}`);
      throw new Error(`Erreur de récupération: ${response.statusText}`);
    }
    
    const assets = await response.json();
    if (import.meta.env.MODE !== 'production') {
      console.log(`[API] Réponse: ${assets.length} assets récupérés`);
    }
    return assets;
  } catch (error) {
    console.error("[API] Erreur: Échec de la récupération des assets:", error);
    throw error;
  }
};

// Supprimer un asset
export const deleteAsset = async (assetPath) => {
  try {
    if (import.meta.env.MODE !== 'production') {
      console.log(`[API] Requête: Suppression d'asset - path: ${assetPath}`);
    }
    
    // Envoyer la demande de suppression au serveur
    const response = await fetch('/api/delete-asset', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ path: assetPath })
    });

    if (!response.ok) {
      console.error(`[API] Erreur: Suppression d'asset - Status: ${response.status}, Message: ${response.statusText}`);
      throw new Error(`Erreur de suppression: ${response.statusText}`);
    }

    if (import.meta.env.MODE !== 'production') {
      console.log(`[API] Réponse: Asset supprimé avec succès - path: ${assetPath}`);
    }
    return true;
  } catch (error) {
    console.error("[API] Erreur: Échec de la suppression de l'asset:", error);
    throw error;
  }
}; 